import { VideoModel } from '../../api/video';
const GB = 1024 * 1024 * 1024;
const MAX_VIDEO_SIZE = 1 * GB;

const presenceVideo = function(video) {
  if (video instanceof VideoModel && video.file.size > MAX_VIDEO_SIZE) {
    return 'size should be less than 1GB.';
  }
};

export default presenceVideo;



// WEBPACK FOOTER //
// ./src/utilites/validate/presenceVideo.js